const API_ERRORS = {
  DEFAULT_MSG: "Oops! Something went wrong, Please try again.",
  "REV-0001": "Invalid filed type used",
  "REV-0002": "Out Of Range",
  "REV-0003": "Length Invalid",
  "REV-0004": "Invalid Select Value",
  "REV-0005": "Field Missing",
  "REV-0006": "Invalid Date Format",
  "REV-0009":
    "Signer email ID is invalid or signer first and last name is not added. Please recheck.",
  "REV-0010":
    "Signature block is falling out of page. Reposition with adequate space below to add name and date tags.",
  "REV-0011":
    "Failed to initiate eSign process. Please resend document for eSign.",
  "REV-0012":
    "One or more signature blocks have no signers assigned. Please recheck.",
  "REV-0013":
    "This PDF contains incomplete fields and cannot be sent for eSign. Please regenerate the PDF from source, upload and retry.",
  "REV-0014":
    "Similar signers added in multiple blocks. Add all signer details in lower case only",
  "REV-0015":
    "Could not complete eSign process. Please resend document for eSign",
};

// eslint-disable-next-line import/prefer-default-export
export { API_ERRORS };



// WEBPACK FOOTER //
// ./src/constants/errorMsg.js